import { Box, Dialog } from "@mui/material";
import { applyPromoCode } from "./images";
import { couponApplied, couponRewardMessage, enjoyBenefits } from "./messages";
import Text from "./text/Text";

function CodeAppliedDialog({ codeAppliedPopupOpen, setCodeAppliedPopupOpen }) {
  return (
    <Dialog
      open={codeAppliedPopupOpen}
      onClose={() => setCodeAppliedPopupOpen(false)}
      PaperProps={{
        sx: {
          overflow: "visible",
          borderRadius: "8px",
        },
      }}
    >
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        flexDirection="column"
        textAlign="center"
      >
        <img
          src={applyPromoCode}
          height={50}
          width={50}
          alt="coupon_code"
          style={{
            position: "absolute",
            top: "-25px",
          }}
        />{" "}
        <Box>
          <Box
            sx={{
              borderBottom: "1px dashed #A4A9B7",
            }}
            padding="24px"
            marginTop="8px"
            gap={1.5}
          >
            <Text font="semibold" size={20}>
              {couponApplied}
            </Text>
            <Text font="regular" size={16}>
              {couponRewardMessage}
            </Text>
          </Box>
          <Text
            font="regular"
            size={14}
            color="primary"
            sx={{
              margin: "8px",
            }}
          >
            {enjoyBenefits}
          </Text>
        </Box>
      </Box>
    </Dialog>
  );
}

export default CodeAppliedDialog;
